import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Combina classes Tailwind respeitando precedência de utilitários. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
